import { Input } from "@trackman/web-shared-components";
import { useTranslation } from "react-i18next";
import { ReactComponent as SearchIcon } from 'images/icons/Search.svg';
import './StudentsSearch.scss';

export const StudentsSearchInput = ({ label, value, onChange }: { label: string; value: string; onChange: (newValue: string) => void }) => {
  const { t } = useTranslation();

  return (
    <div className='students-search'>
      <Input
        label={label}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <SearchIcon />
    </div>
  );
};
